import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material"

import { BooleanInput, SaveButton, SelectInput, Toolbar, } from "react-admin"
import { LocationInput } from "../LocationInput"


export const SectionUserEditLocation = () => {
    return (
        <Card variant="outlined">
            <CardHeader title={"Location"} />
            <CardContent>
                <Typography variant="h6">Search Location</Typography>
                <BooleanInput source="freezeSearchLocation" helperText={false} />
                <SelectInput label="Source" source="searchLocation.source" helperText={false} variant="outlined"
                    choices={[
                        { id: 'location', name: "Location" },
                        { id: 'city', name: "City" },
                        { id: 'ipLocation', name: "Ip Location" }
                    ]} />

                <LocationInput source="searchLocation" />
                <Box component={"p"} />
                <Typography variant="h6">Location</Typography>
                <LocationInput source="location" />
            </CardContent>
            <Toolbar
            //{...sanitizeToolbarProps(formProps)}
            >
                <SaveButton label="Save" />
            </Toolbar>
        </Card>
    )
}


